<header>
    <strong class="toggleExchangeRateTable" (click)="isDisplayExchangeRateTable=!isDisplayExchangeRateTable">
        {{!isDisplayExchangeRateTable ? wording.displayExchangeRateTable : wording.hideExchangeRateTable}}&nbsp;
        <fa-icon [icon]="(!isDisplayExchangeRateTable ? chevronDown : chevronUp)"></fa-icon>
    </strong>
    <notification *ngIf="exchangeRateTableData.length"
                  [type]="isExchangeRateDataStatusError ? notificationType.Error : notificationType.Success">
        {{exchangeRateDataStatus}}
        <ng-container *ngIf="isExchangeRateDataStatusError">
            <btn [value]="wording.refreshExchangeRate" (onClick)="refreshExchangeRate()" [type]="refreshButtonType"></btn>
        </ng-container>
    </notification>
</header>
<ng-container *ngIf="isDisplayExchangeRateTable">
    <table *ngIf="exchangeRateTableData.length else noExchangeRateTableData;" mat-table [dataSource]="exchangeRateTableData">
        <ng-container *ngFor="let displayedColumn of displayedColumns" [matColumnDef]="displayedColumn">
            <th mat-header-cell *matHeaderCellDef>{{wording[displayedColumn]}}</th>
            <td mat-cell *matCellDef="let element">
                <ng-container *ngIf="displayedColumn==='currency' ">
                    {{element[displayedColumn]}}
                </ng-container>
                <ng-container *ngIf="displayedColumn==='rateUsed' ">
                    <ng-container *ngIf="element[displayedColumn]!==notAvailable else notRateUsedTemplate">
                        {{+element[displayedColumn]| number:'1.6-6':locale}}
                    </ng-container>
                    <ng-template #notRateUsedTemplate>{{element[displayedColumn]}}</ng-template>
                </ng-container>
                <div *ngIf="displayedColumn==='rateAvailable'" [class]="'rateAvailable ' + (isOneDifference ? 'between' : 'center')" >
                    <ng-container *ngIf="element[displayedColumn][0]!==notAvailable else notRateAvailableTemplate">
                        <span>{{+element[displayedColumn][0]| number:'1.6-6':locale}}</span>
                        <div *ngIf="element[displayedColumn].length===2">
                            (<strong><ng-container *ngIf="+element[displayedColumn][1]>0">+</ng-container>{{+element[displayedColumn][1]| number:'1.6-6':locale}}</strong>)
                        </div>
                    </ng-container>
                    <ng-template #notRateAvailableTemplate>
                        {{element[displayedColumn][0]}}
                    </ng-template>
                </div>
            </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
</ng-container>
<ng-template #noExchangeRateTableData>
    <notification style="margin-top: 0.75rem;" [type]="notificationType.Warning">
        {{wording.noExchangeRateTableData}}
    </notification>
</ng-template>